export type { SavedAccountsModalTranslations } from "./saved-accounts-modal-pt-br";
export { SAVED_ACCOUNTS_MODAL_PT_BR } from "./saved-accounts-modal-pt-br";
export { SAVED_ACCOUNTS_MODAL_EN_US } from "./saved-accounts-modal-en-us";
export { SAVED_ACCOUNTS_MODAL_ES_MX } from "./saved-accounts-modal-es-mx";
export { SAVED_ACCOUNTS_MODAL_FR_FR } from "./saved-accounts-modal-fr-fr";
